export const texts = {
  emailLabel: {
    de: 'E-Mail',
    en: 'Email'
  },
  passwordLabel: {
    de: 'Passwort',
    en: 'Password'
  },
  submit: {
    de: 'Anmelden',
    en: 'Sign in'
  },
  forgotPrompt: {
    de: 'Du hast dein Passwort vergessen?',
    en: 'Forgot your password?'
  },
  forgotLink: {
    de: 'Passwort anfordern',
    en: 'Request password'
  },
  errors: {
    missingBoth: {
      de: 'Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein',
      en: 'Please enter your email address and password'
    },
    missingPassword: {
      de: 'Bitte geben Sie Ihr Passwort ein',
      en: 'Please enter your password'
    },
    missingEmail: {
      de: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      en: 'Please enter your email address'
    },
    mergeFailed: {
      de: 'Die Einladung konnte nicht zur Shortlist umgeschrieben werden. Bitte wenden Sie sich an skillconomy.',
      en: 'The invitation could not be transferred to the shortlist. Please contact skillconomy.'
    },
    generic: {
      de: 'Ein Fehler ist aufgetreten',
      en: 'An error occurred'
    }
  }
};
